import React from "react";
import {
  AreaChart,
  Area,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const LineGraphWidget = ({ data, strokeColor }) => {
  return (
    <>
      <div className="widget-card">
        <ResponsiveContainer
          className="widget-recharts-responsive-container"
          width={"99%"}
          height={"99%"}
        >
          <AreaChart width={400} height={250} data={data}>
            <defs>
              <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={strokeColor} stopOpacity={0.5} />
                <stop offset="70%" stopColor={strokeColor} stopOpacity={0} />
              </linearGradient>
            </defs>

            <CartesianGrid stroke="#dedede" />
            <XAxis dataKey="dayNo" stroke="#dedede" />
            <YAxis stroke="#dedede" type="number" />
            {
              // <Line type="monotone" dataKey="pv" stroke="#4fbfd7" />
            }
            <Area
              type="monotone"
              dataKey="value"
              stroke={strokeColor}
              strokeWidth={3}
              fillOpacity={1}
              fill="url(#colorUv)"
            />
            {
              //<Line type="monotone" dataKey="amt" stroke="#da1e28" />
            }

            <Tooltip />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </>
  );
};

export default LineGraphWidget;
